export default __webpack_public_path__ + "static/media/student-link.87de53fa.svg";